import Vue from 'vue'

Vue.component('StatGroupBySituation', () => import('./StatGroupBySituation.vue'))
Vue.component('StatGroupTable', () => import('./StatGroupTable.vue'))